/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServiceDeliveryLocationRoleTypeModel } from '../../models/service-delivery-location-role-type-model';

export interface ServiceDeliveryLocationRoleTypeIdGet$Params {
  id: string;
}

export function serviceDeliveryLocationRoleTypeIdGet(http: HttpClient, rootUrl: string, params: ServiceDeliveryLocationRoleTypeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<ServiceDeliveryLocationRoleTypeModel>> {
  const rb = new RequestBuilder(rootUrl, serviceDeliveryLocationRoleTypeIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<ServiceDeliveryLocationRoleTypeModel>;
    })
  );
}

serviceDeliveryLocationRoleTypeIdGet.PATH = '/ServiceDeliveryLocationRoleType/{id}';
